import { ComposedElement } from "../ComposedElement.mjs";
export var QuoteNode;

(function (QuoteNode) {
  QuoteNode.TYPE = 'block-quote';

  function isQuoteNode(value) {
    return ComposedElement.isComposedElement(value, QuoteNode.TYPE);
  }

  QuoteNode.isQuoteNode = isQuoteNode;

  function validateQuoteNode(value, validateInlineNode) {
    var isValid = ComposedElement.validateComposedElement(value, QuoteNode.TYPE, validateInlineNode);
    return isValid ? value : null;
  }

  QuoteNode.validateQuoteNode = validateQuoteNode;
})(QuoteNode || (QuoteNode = {}));